export default __webpack_public_path__ + "static/media/footerlogo.81cd7c56.svg";